/**
 * Bridges the custom hand-rolled `<select class="product-variant-select">`
 * variant pickers rendered in sections/main-product.liquid (the theme's
 * `product-variant-picker` render call is currently commented out there,
 * replaced with plain <select> markup that is never wrapped in Dawn's
 * <variant-selects> custom element) back to Shopify/Dawn's own variant
 * data so price, compare-at price, variant id, and availability update
 * correctly when a shopper picks a different option.
 *
 * Defensive by design: no-ops instantly on any page/section that doesn't
 * have this markup, so it never interferes with normal Dawn product pages.
 * Shopify variant data (fetched live) remains the single source of truth;
 * nothing here hardcodes a price.
 */
(function () {
  function stripIndicator(text) {
    return (text || '').trim().replace(/^[✅❌]\s*/, '').trim();
  }

  function findVariant(variants, selects) {
    var selected = Array.prototype.map.call(selects, function (sel) {
      var opt = sel.options[sel.selectedIndex];
      return stripIndicator(opt ? opt.textContent : '');
    });

    return variants.find(function (variant) {
      var opts = [variant.option1, variant.option2, variant.option3].filter(function (o) {
        return o !== null && o !== undefined;
      });
      if (opts.length !== selected.length) return false;
      return opts.every(function (opt, i) {
        return opt === selected[i];
      });
    });
  }

  function syncSelectsToVariant(variantId, selects, variants) {
    var variant = variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (!variant) return;
    var optValues = [variant.option1, variant.option2, variant.option3];
    selects.forEach(function (sel, i) {
      var target = optValues[i];
      if (target == null) return;
      for (var j = 0; j < sel.options.length; j++) {
        if (stripIndicator(sel.options[j].textContent) === target) {
          sel.selectedIndex = j;
          break;
        }
      }
    });
  }

  function initProductInfo(productInfo) {
    var selects = productInfo.querySelectorAll('select.product-variant-select');
    if (!selects.length) return;

    var sectionId = productInfo.dataset.section;
    var productUrl = productInfo.dataset.url;
    if (!sectionId || !productUrl) return;

    var form = productInfo.querySelector('form[data-type="add-to-cart-form"]');
    var hiddenIdInput = form ? form.querySelector('input[name="id"]') : null;

    var variantsPromise = null;
    function getVariants() {
      if (!variantsPromise) {
        variantsPromise = fetch(productUrl + '.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            return data.variants;
          });
      }
      return variantsPromise;
    }

    // On load, the price/SKU/id are already server-rendered by Liquid for the
    // correct variant (e.g. from a ?variant=... URL), but this theme's hand-rolled
    // <select> markup doesn't mark the matching <option> as selected. Sync the
    // dropdown's visual state to match on init so it never looks out of sync with
    // the price shown or the variant that Add to Cart will actually submit.
    if (hiddenIdInput && hiddenIdInput.value) {
      getVariants()
        .then(function (variants) {
          syncSelectsToVariant(hiddenIdInput.value, selects, variants);
        })
        .catch(function (err) {
          console.error('[product-variant-select-fix] initial sync failed', err);
        });
    }

    function swapFragment(doc, id, toggleHiddenFn) {
      var source = doc.getElementById(id + '-' + sectionId);
      var destination = productInfo.querySelector('#' + id + '-' + sectionId);
      if (source && destination) {
        destination.innerHTML = source.innerHTML;
        if (toggleHiddenFn) destination.classList.toggle('hidden', toggleHiddenFn(source));
      }
    }

    function updateFromVariant(variant) {
      if (hiddenIdInput) {
        hiddenIdInput.value = variant ? variant.id : '';
        hiddenIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (!variant) return;

      fetch(productUrl + '?variant=' + variant.id + '&section_id=' + encodeURIComponent(sectionId))
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          swapFragment(doc, 'price', null);
          swapFragment(doc, 'Sku', function (el) {
            return el.classList.contains('hidden');
          });
          swapFragment(doc, 'Inventory', function (el) {
            return el.innerText === '';
          });
          swapFragment(doc, 'Volume', null);
          swapFragment(doc, 'Price-Per-Item', function (el) {
            return el.classList.contains('hidden');
          });

          var submitButton = productInfo.querySelector('#ProductSubmitButton-' + sectionId);
          var newSubmitButton = doc.getElementById('ProductSubmitButton-' + sectionId);
          if (submitButton && newSubmitButton) {
            var disabled = newSubmitButton.hasAttribute('disabled');
            submitButton.toggleAttribute('disabled', disabled);
            var span = submitButton.querySelector('span');
            var newSpan = newSubmitButton.querySelector('span');
            if (span && newSpan) span.textContent = newSpan.textContent;
          }

          if (productInfo.dataset.updateUrl !== 'false') {
            window.history.replaceState({}, '', productUrl + '?variant=' + variant.id);
          }
        })
        .catch(function (err) {
          console.error('[product-variant-select-fix] variant update failed', err);
        });
    }

    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        getVariants()
          .then(function (variants) {
            updateFromVariant(findVariant(variants, selects));
          })
          .catch(function (err) {
            console.error('[product-variant-select-fix] failed to load variants', err);
          });
      });
    });
  }

  function init() {
    var productInfos = document.querySelectorAll('product-info');
    if (!productInfos.length) return;
    productInfos.forEach(initProductInfo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
